<script lang="ts">
import type Map from 'ol/Map'
import { inject } from 'vue'
import Popup from 'ol-ext/overlay/Popup'
import type { FeatureLike } from 'ol/Feature'
import type { SimpleGeometry } from 'ol/geom'

export default {
    name: 'DkOlPopup',
    components: {},
    props: {
        feature: {
            type: Object,
            required: false,
            default: null,
        },
        html: {
            type: String,
            required: false,
            default: null,
        },
        popupClass: {
            type: String, // 'default',"tooltips", "warning" "black" "default", "tips", "shadow",
            required: false,
            default: 'default',
        },
    },
    data() {
        return {
            popup: null as Popup,
        }
    },
    computed: {
        htmlContent(): string {
            if (this.html) {
                return this.html
            }
            let content = '<table>'
            for (const key of this.feature.getKeys()) {
                if (!['geometry'].includes(key)) {
                    content += `<tr><th>${key}</th><td>${this.feature.get(key)}</td></tr>`
                }
            }
            content += '</table>'
            return content
        },
    },
    watch: {},
    mounted(): void {
        const map: Map = inject('map')
        this.popup = new Popup({
            popupClass: this.popupClass,
            closeBox: true,
            positioning: 'auto',

            autoPan: {
                animation: { duration: 250 },
            },
        })
        map.addOverlay(this.popup)
    },

    unmounted(): void {
        const map: Map = inject('map')
        map.removeOverlay(this.popup)
        delete this.popup
    },
    methods: {
        show(delayed: boolean = true): void {
            if (delayed) {
                setTimeout(() => {
                    this.show(false)
                })
                return
            }
            const coordinates = ((this.feature as FeatureLike).getGeometry() as SimpleGeometry).getFirstCoordinate()

            this.popup.show(coordinates, this.htmlContent)
        },
        hide(): void {
            this.popup.hide()
        },
    },
}
</script>

<template>
    <div class="dk-ol-popup" />
</template>

<style scoped>

</style>
